export default __webpack_public_path__ + "static/media/travel.1791e2eb.png";